import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormService} from "./form.service";
import {HttpClientModule} from '@angular/common/http';
import {ApiService} from "./api.service";
import {WindowRefService} from "./window.service";
import {AppService} from "./app.service";
import {AnalyticsService} from "./analytics.service";
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { TokenCookieService } from './token-cookie.service';
/** The NgModule for the Utils feature */
@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RecaptchaModule,
        RecaptchaFormsModule
    ],
    providers: [
        WindowRefService,
        FormService,
        ApiService,
        AppService,
        AnalyticsService,
        TokenCookieService,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: { } as RecaptchaSettings,
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'en',
        }
    ],
    exports: [
        // FormService,
        //AppService
    ]
})

class UtilsModule {
}

export {UtilsModule};